import editAssetsReducer from '../state/edit-asset-slice'

export interface AssetsReducers {
  editAssets: typeof editAssetsReducer
}

export const assetsReducers: AssetsReducers = {
  editAssets: editAssetsReducer
}
